/// <amd-module name="TFS/DRITools/util/Columns" />
export const knownActivityLogColumns: string[] = [
    "TIMESTAMP",
    "PreciseTimeStamp",
    "Tenant",
    "Role",
    "RoleInstance",
    "Region",
    "ScaleUnit",
    "DeploymentId",
    "Level",
    "ProviderGuid",
    "ProviderName",
    "EventId",
    "Pid",
    "Tid",
    "OpcodeName",
    "KeywordName",
    "TaskName",
    "ChannelName",
    "EventMessage",
    "HostId",
    "ContextId",
    "Application",
    "Command",
    "Status",
    "Count",
    "StartTime",
    "ExecutionTime",
    "IdentityName",
    "IPAddress",
    "UniqueIdentifier",
    "UserAgent",
    "CommandIdentifier",
    "ExceptionType",
    "ExceptionMessage",
    "ActivityId",
    "ResponseCode",
    "VSID",
    "TimeToFirstPage",
    "ActivityStatus",
    "ExecutionTimeThreshold",
    "IsExceptionExpected",
    "DelayTime",
    "RelatedActivityId",
    "RowKey",
    "SourceNamespace",
    "SourceMoniker",
    "SourceVersion",
    "DeploymentSlot",
    "LogicalReads",
    "PhysicalReads",
    "CPUTime",
    "ElapsedTime",
    "Feature",
    "HostStartTime",
    "HostType",
    "ParentHostId",
    "AnonymousIdentifier",
    "SqlExecutionTime",
    "SqlExecutionCount",
    "RedisExecutionTime",
    "RedisExecutionCount",
    "AadExecutionTime",
    "AadExecutionCount",
    "BlobStorageExecutionTime",
    "BlobStorageExecutionCount",
    "TableStorageExecutionTime",
    "TableStorageExecutionCount",
    "ServiceBusExecutionTime",
    "ServiceBusExecutionCount",
    "VssClientExecutionTime",
    "VssClientExecutionCount",
    "SqlRetryExecutionTime",
    "SqlRetryExecutionCount",
    "SqlReadOnlyExecutionTime",
    "SqlReadOnlyExecutionCount",
    "CPUCycles",
    "FinalSqlCommandExecutionTime",
    "E2EID",
    "PersistentSessionId",
    "PendingAuthenticationSessionId",
    "CurrentAuthenticationSessionId",
    "ApplicationHash",
    "CommandHash",
    "CUID",
    "TenantId",
    "ProviderId",
    "QueueTime",
    "AuthenticationMechanism",
    "Environment",
    "TSTUs",
    "AadGraphExecutionTime",
    "AadGraphExecutionCount",
    "AadTokenExecutionTime",
    "AadTokenExecutionCount",
    "ThrottleReason",
    "Referrer",
    "UriStem",
    "SupportsPublicAccess",
    "ConcurrencySemaphoreTime",
    "AuthorizationId",
    "MethodInformationTimeout"
];
